import {bindActionCreators} from 'redux';
import * as UserFeedbackActions from '../actions/UserFeedbackActions';
import {store} from '../store';

export const openFeedbackModal = bindActionCreators(
    UserFeedbackActions.openFeedbackModal,
    store.dispatch
);

export const closeFeedbackModal = bindActionCreators(
    UserFeedbackActions.closeFeedbackModal,
    store.dispatch
);
